export function removeUnderscoresFromString({
  str,
  isCapitalized,
}: {
  str: string;
  isCapitalized: boolean;
}) {
  if (isCapitalized) {
    return str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  } else {
    return str.split('_').join(' ');
  }
}
